import React, { useEffect, useState } from "react";
import cameras from "./cameras.json";
import "./App.css";

const BASE_URL = "http://hoko.pnwas.org/images/webcam";
const WEATHER_URL = "https://app.weathercloud.net/device/sticker/2110855076";

const cameraUrl = (name) => `${BASE_URL}/${name}/current.jpg?t=${Date.now()}`;

// Insert weather widget in the middle of the camera list
const mid = Math.floor(cameras.length / 2);
const KEYS = [
  ...cameras.slice(0, mid).map((c) => c.name),
  "weather",
  ...cameras.slice(mid).map((c) => c.name),
];

const buildInitialSrcs = () => {
  const srcs = { weather: `${WEATHER_URL}?t=${Date.now()}` };
  cameras.forEach((cam) => { srcs[cam.name] = cameraUrl(cam.name); });
  return srcs;
};

const ImageComponent = ({ src, name, onClick, className }) => {
  const imgElement = <img src={src} alt={name} onClick={onClick} className={className} />;
  if (src.startsWith("https://app.weathercloud.net")) {
    return (
      <a href="https://www.wunderground.com/dashboard/pws/KWASEKIU17">
        {imgElement}
      </a>
    );
  }
  return imgElement;
};

const App = () => {
  const [imageSrcs, setImageSrcs] = useState(buildInitialSrcs);
  const [fullScreenKey, setFullScreenKey] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      // Each camera preloads in the background; src swaps only when the image is ready
      cameras.forEach((cam) => {
        const src = cameraUrl(cam.name);
        const img = new Image();
        img.onload = () => setImageSrcs((prev) => ({ ...prev, [cam.name]: src }));
        img.src = src;
      });
      // Weather widget is a remote sticker — update directly
      setImageSrcs((prev) => ({ ...prev, weather: `${WEATHER_URL}?t=${Date.now()}` }));
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggleFullScreen = (key) => {
    if (key === "weather") return;
    setFullScreenKey(fullScreenKey === key ? null : key);
  };

  return (
    <div className="App">
      <div className={`images-container ${fullScreenKey ? "hidden" : ""}`}>
        {KEYS.map((key) => (
          <ImageComponent
            key={key}
            src={imageSrcs[key]}
            name={key}
            onClick={() => toggleFullScreen(key)}
            className="grid-image"
          />
        ))}
      </div>

      {fullScreenKey && (
        <div
          className="fullscreen-container"
          onClick={() => setFullScreenKey(null)}
        >
          <ImageComponent
            src={imageSrcs[fullScreenKey]}
            name={fullScreenKey}
            className="fullscreen-image"
          />
        </div>
      )}
    </div>
  );
};

export default App;
